import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addProductionStage } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useAddProductionStage(orderId: string) {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: { name: string; description: string }) => {
      if (!accessToken) throw new Error("Not authenticated")
      return addProductionStage(orderId, payload, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["seller-order-detail", orderId] })
      queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", orderId] })
      queryClient.invalidateQueries({ queryKey: ["admin-order-detail", orderId] })
    },
  })
}
